export default "__VITE_ASSET__CYdfjPeE__"